import { render, staticRenderFns } from "./Mingye_Vip.vue?vue&type=template&id=574afde4&scoped=true"
import script from "./Mingye_Vip.vue?vue&type=script&lang=js"
export * from "./Mingye_Vip.vue?vue&type=script&lang=js"
import style0 from "./Mingye_Vip.vue?vue&type=style&index=0&id=574afde4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574afde4",
  null
  
)

export default component.exports